export default {
  "rowSelection": false,
  "rowKey": "itemId",
  "columns": [
    {
      "title": "门店",
      "dataIndex": "companyNames",
      "width": 160,
      "ellipsis": true
    },
    {
      "title": "金额(月/¥)",
      "dataIndex": "amount",
      "width": 140,
      "render": "money"
    },
    {
      "title": "周期（月）",
      "dataIndex": "numOfmonthPriod",
      "width": 140
    },
    {
      "title": "警戒金额(¥)",
      "dataIndex": "amountWarn",
      "width": 160,
      "render": "money"
    },
    {
      "title": "有效周期",
      "dataIndex": "startDate",
      "render": "startDateFn",
      "width": 300
    },
    {
      "title": "扣费方式",
      "dataIndex": "deductionMethodName",
      "width": 120
    },
    {
      "title": "状态",
      "dataIndex": "enabled",
      "render": "enabledFn",
      "width": 100
    },
    {
      "title": "操作人员",
      "dataIndex": "modifiedByName",
      "width": 200
    },
    {
      "title": "最后操作时间",
      "dataIndex": "lastUpdatedTime",
      "itemType": "dateTime",
      "width": 200
    },
    {
      "title": "操作",
      "dataIndex": "operation",
      "width": 120,
      "fixed": "right",
      "render": "operationFn"
    }
  ],
  "search": [
    {
      name: "companyIds",
      label: "门店",
      itemType: "custom",
      render: "setCompany"
    },
    {
      "name": "enabled",
      "label": "状态",
      "itemType": "select",
      "key": "code",
      "labelKey": "name",
      "showSearch": true,
      "optionFilterProp": "children",
      "allowClear": true,
      "data": "enabledList"
    }
    
  ],
  "footer": [
    {
      "label": "新增",
      "type": "primary",
      "auth": "insurancesettingOnAddOrEdit",
      "events": ["onClick:onAddOrEdit"]
    }
  ]
}
